import React from 'react';

const Privacy: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6">
      <h1 className="text-3xl font-bold text-domired-600 mb-6">Política de Privacidad</h1>
      
      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-semibold mb-2">Nuestro Compromiso con tu Privacidad</h2>
          <p className="text-gray-700 dark:text-gray-300">
            En DomiRed, respetamos profundamente la privacidad de nuestros usuarios. 
            Entendemos la importancia de la información personal y nos comprometemos 
            a protegerla con los más altos estándares.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold mb-2">Información que Recopilamos</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Solo recopilamos la información necesaria para brindarte una experiencia 
            personalizada y mejorar nuestros servicios. Esto puede incluir tu nombre, 
            correo electrónico, foto de perfil y contenido que compartes en la plataforma.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold mb-2">Uso de la Información</h2>
          <p className="text-gray-700 dark:text-gray-300">
            No compartimos ni vendemos tu información personal a terceros. 
            Utilizamos tu información únicamente para mejorar tu experiencia 
            en DomiRed y personalizar el contenido que ves.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold mb-2">Cookies y Tecnologías Similares</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Utilizamos cookies y tecnologías similares para mejorar la funcionalidad 
            de nuestra plataforma, recordar tus preferencias y ofrecerte una experiencia 
            más personalizada. Puedes configurar tu navegador para rechazar todas las 
            cookies o para que te avise cuando se envíe una cookie.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold mb-2">Seguridad</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Implementamos medidas de seguridad técnicas y organizativas para proteger 
            tu información personal contra accesos no autorizados, alteraciones, 
            divulgaciones o destrucciones.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold mb-2">Cambios a esta Política</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Podemos actualizar nuestra política de privacidad ocasionalmente. 
            Te notificaremos sobre cualquier cambio significativo y te recomendamos 
            revisar esta página periódicamente.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
